import React, { useEffect } from 'react';
import { useIntl } from "@edx/frontend-platform/i18n";
import {
  FormAutosuggestOption,
  FormControlFeedback,
} from "@openedx/paragon";
import AuthFormAutosuggest from "./AuthFormAutosuggest";
import classNames from "classnames";
import PropTypes from "prop-types";
import messages from "../messages";
import townsObj from './towns.json';

const TownField = (props) => {
    const towns = townsObj;
  const { formatMessage } = useIntl();
  const {
    onChangeHandler,
    handleErrorChange,
    selectedRegion,
    onFocusHandler,
    selectedTown,
    errorMessage,
    occupation,
  } = props;

  useEffect(() => {
      if (props.errorMessage === undefined){
        return
      }
      if (props.errorMessage !== "") {
        handleOnChange("");
      }
      
    }, [errorMessage]);
  
  const handleOnChange = (value) => {
    
    onChangeHandler({ target: { name: 'town', value: value } });
  }

  let townsList = selectedRegion === '' ? towns.all : towns[selectedRegion];
  return (
    <div className="mb-4">
      <AuthFormAutosuggest
       floatingLabel={
        `${occupation === 'teacher'
          ? formatMessage(messages["town_teacher"])
          : ['student', 'pupil'].includes(occupation)
          ? formatMessage(messages["town_student"])
          : formatMessage(messages["town"])
        } *`
      }       
        aria-label="form autosuggest"
        name="town"
        onFocus={(e) => onFocusHandler(e)}
        value={selectedTown}
        className={classNames({ "form-field-error": props.errorMessage })}
        onChange={(value) => handleOnChange(value)}
      >
        {townsList.map((town) => (
          <FormAutosuggestOption key={town} id={town}>
           {town}
          </FormAutosuggestOption>
        ))}
      </AuthFormAutosuggest>
      {props.errorMessage !== "" && (
        <FormControlFeedback
          key="error"
          className="form-text-size"
          hasIcon={false}
          feedback-for="occupation"
          type="invalid"
        >
          {props.errorMessage}
        </FormControlFeedback>
      )}
    </div>
  );
};

export default TownField;
